export const BRAND = {
  name: 'Tu Iglesia App',
  product: 'BOMM',
  tagline_es: 'Tu aliado en el Ministerio de Cristo',
  tagline_en: 'Your ally in the Ministry of Christ',
  logoWhite:
    'https://customer-assets.emergentagent.com/job_sanctuary-admin/artifacts/h232tq5u_LOGO%20Iglesia%20Blanco%203.png',
  logoColor:
    'https://customer-assets.emergentagent.com/job_sanctuary-admin/artifacts/k2nlklmi_LOGO%20Iglesia%202.png',
  cyan: '#00CCFF',
  deep: '#056A84',
};
